/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import {
  AddMemberForm,
  Feedbacktext,
  InputLabel,
  InputWrapper,
  PopupInput,
  UpdateButton,
} from './editReferrerElements';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';

// Default state
const initialState = {
  name: '',
  id: 0,
};

const EditWaitlistPopup = ({
  setOpen, setData, selected, trigger, data,
}) => {
  const axiosPrivate = useAxiosPrivate();

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [state, setState] = useState(initialState);

  const handleInput = (e) => {
    const input = e.currentTarget.name;
    const { value } = e.currentTarget;

    setState((prev) => ({ ...prev, [input]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!state.name) {
      return setFeedback('Name cant be empty');
    }

    setLoading(true);

    axiosPrivate.post(
      '/editReferrer',
      JSON.stringify({
        name: state.name,
        id: state.id,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'error') {
        setLoading(false);
        setFeedback(res.data.message ? res.data.message : 'Something went wrong');
        setState(initialState);
      } else {
        setFeedback(res.data.message);
        const editedData = data.map((item) => {
          if (item.ID === selected.ID) {
            return {
              ...item,
              Name: state.name,
              ID: state.id,
            };
          } return item;
        });
        setData(editedData);
        setState(initialState);
        setTimeout(() => {
          setLoading(false);
          setOpen(false);
          setFeedback('');
        }, 1000);
      }
    }).catch((error) => {
      setLoading(false);
      setFeedback(error.response?.data ? error.response.data.message : 'Something went wrong');
      setState(initialState);
    });
  };

  // Error handling
  useEffect(() => {
    if (state.name) { setFeedback(''); }
  }, [state.name]);

  useEffect(() => {
    setState({
      name: selected.Name ? selected.Name : '',
      id: selected.ID ? selected.ID : '',
    });
  }, [trigger]);

  return (
    <AddMemberForm onSubmit={handleSubmit}>
      <InputWrapper>
        <InputLabel htmlFor="name">Name:</InputLabel>
        <PopupInput
          value={state.name}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="name"
        />
      </InputWrapper>
      <UpdateButton disabled={loading} type="submit">{loading ? 'Editing referrer' : 'Edit referrer'}</UpdateButton>
      {feedback && <Feedbacktext>{feedback}</Feedbacktext>}
    </AddMemberForm>
  );
};

export default EditWaitlistPopup;
